export const urlAbsoluteToRelative = (url: string) => {
  if (!url) return '/';
  let navigateUrl = url;

  if (navigateUrl.startsWith('http://') || navigateUrl.startsWith('https://')) {
    try {
      const urlObj = new URL(navigateUrl);
      navigateUrl = urlObj.pathname + urlObj.search + urlObj.hash;
    } catch {
      navigateUrl = '/';
    }
  }

  return navigateUrl;
};
